
import { PageLayout } from "@/components/layout/PageLayout";
import { HeroSection } from "@/components/specializations/securityawareness/HeroSection";
import { ServiceCards } from "@/components/specializations/securityawareness/ServiceCards";
import { ProcessSteps } from "@/components/specializations/securityawareness/ProcessSteps";
import { ValueMetricsSection } from "@/components/specializations/securityawareness/ValueMetricsSection";
import { CtaSection } from "@/components/specializations/securityawareness/CtaSection";

const SecurityAwarenessTraining = () => {
  return (
    <PageLayout
      title="Security Awareness Training"
      description="Transform your employees from potential vulnerabilities to tactful defenders with our comprehensive security awareness training program."
      keywords={[
        "security awareness", 
        "phishing training", 
        "employee cybersecurity", 
        "security training", 
        "cyber awareness"
      ]}
      canonicalUrl="/cybersecurity/security-awareness-training/"
      schema={{
        type: "service",
        data: {
          name: "Security Awareness Training",
          description: "Transform your employees from potential vulnerabilities to tactful defenders with our comprehensive security awareness training program.",
          provider: {
            name: "edgefi",
            sameAs: "https://edgefi.com"
          }
        }
      }}
    >
      <HeroSection />
      <ServiceCards />
      <ProcessSteps />
      <ValueMetricsSection />
      <CtaSection />
    </PageLayout>
  );
};

export default SecurityAwarenessTraining;
